// eslint-disable-next-line import/no-cycle
import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const getSourceListApi = (params = {}) =>
  DataService.get(`/sources${Object.keys(params).length ? `?${getQueryString(params)}` : ''}`);

export const createSourceApi = (data) => DataService.post('/source', data);

export const getSourceDetailApi = (sourceId) => DataService.get(`/source/${sourceId}`);

export const updateSourceStatusApi = (sourceId, status) => DataService.put(`/source/${sourceId}/status`, { status });
